export const communicationRows = [
  {
    patient: 'Forte, Peter',
    category: 'Lab Results',
    routeTo: 'Dr. Henry Low',
    priority: 'High',
    status: 'Awaiting Provider'
  },
  {
    patient: 'Willow, Gwen Marry',
    category: 'Medication',
    routeTo: 'Dr. Alice William',
    priority: 'Routine',
    status: 'Notify Patient'
  },
  {
    patient: 'Philips, Cammiee John',
    category: 'Clinical Follow-up',
    routeTo: 'Dr. Elizabeth David',
    priority: 'High',
    status: 'Awaiting Provider'
  },
  {
    patient: 'Samuel, Sagar John',
    category: 'Imaging Review',
    routeTo: 'Dr. Alice William',
    priority: 'Routine',
    status: 'Completed'
  },
  {
    patient: 'Willow, Gwen Marry',
    category: 'Medication',
    routeTo: 'Dr. Alice William',
    priority: 'Routine',
    status: 'Notify Patient'
  },
  {
    patient: 'Philips, Cammiee John',
    category: 'Clinical Follow-up',
    routeTo: 'Dr. Elizabeth David',
    priority: 'Urgent',
    status: 'Awaiting Provider'
  },
  {
    patient: 'Forte, Peter',
    category: 'Lab Results',
    routeTo: 'Dr. Henry Low',
    priority: 'Routine',
    status: 'Completed'
  },
  {
    patient: 'Philips, Cammiee John',
    category: 'Clinical Follow-up',
    routeTo: 'Dr. Elizabeth David',
    priority: 'High',
    status: 'Awaiting Provider'
  },
  {
    patient: 'Willow, Gwen Marry',
    category: 'Medication',
    routeTo: 'Dr. Alice William',
    priority: 'Routine',
    status: 'Notify Patient'
  },
  {
    patient: 'Samuel, Sagar John',
    category: 'Imaging Review',
    routeTo: 'Dr. Alice William',
    priority: 'Routine',
    status: 'Completed'
  }
];

export const providerOptions = [
  'All Providers',
  'Dr. Henry Low',
  'Dr. Alice William',
  'Dr. Elizabeth David'
];

export const statusOptions = [
  'All',
  'Awaiting Provider',
  'Notify Patient',
  'Completed'
];

export const statusColor = {
  'Awaiting Provider': '#F44336',
  'Notify Patient': '#1976D2',
  Completed: '#2E7D32'
};

